import React from 'react';
import { Button, Space, Popconfirm } from 'antd';
import type { FormMode } from '../hooks/usePWP252Mode';

interface ActionBarProps {
  mode: FormMode;
  hasRecord: boolean;
  hasPrev: boolean;
  hasNext: boolean;
  loading: boolean;
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
  onAdd: () => void;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onDelete: () => void;
}

const ActionBar: React.FC<ActionBarProps> = ({
  mode, hasRecord, hasPrev, hasNext, loading,
  onFirst, onPrev, onNext, onLast,
  onAdd, onEdit, onSave, onCancel, onDelete,
}) => {
  const isEditing = mode === 'add' || mode === 'edit';

  return (
    <div className="pwp252-action-bar">
      <Space wrap>
        {/* Navigation — only in view mode */}
        {!isEditing && (
          <>
            <Button size="small" onClick={onFirst} disabled={!hasPrev || loading}>首筆</Button>
            <Button size="small" onClick={onPrev}  disabled={!hasPrev || loading}>上筆</Button>
            <Button size="small" onClick={onNext}  disabled={!hasNext || loading}>下筆</Button>
            <Button size="small" onClick={onLast}  disabled={!hasNext || loading}>末筆</Button>
          </>
        )}

        {/* Actions */}
        {!isEditing && (
          <Button type="primary" size="small" onClick={onAdd} disabled={loading}>新增</Button>
        )}
        {!isEditing && hasRecord && (
          <Button size="small" onClick={onEdit} disabled={loading}>修改</Button>
        )}
        {isEditing && (
          <Button type="primary" size="small" onClick={onSave} loading={loading}>存檔</Button>
        )}
        {isEditing && (
          <Button size="small" onClick={onCancel} disabled={loading}>還原</Button>
        )}
        {!isEditing && hasRecord && (
          <Popconfirm
            title="確認刪除本資料?"
            onConfirm={onDelete}
            okText="確認"
            cancelText="取消"
          >
            <Button danger size="small" disabled={loading}>刪除</Button>
          </Popconfirm>
        )}
      </Space>
    </div>
  );
};

export default ActionBar;
